import { Autocomplete, Box, TextField } from "@mui/material";
import { useQuery } from "@apollo/client";
import { GET_VENDORS } from "../../routes/vendors/graphql";
import { without } from "ramda";
import { Vendor } from "../../__generated__/graphql";
interface IVendorPickerProps {
  handleChange: (vendorId: string, option?: Vendor | null) => void;
  defaultValue?: string;
  value: string | undefined;
  placeholder?: string;
  controlStyle?: React.CSSProperties;
  except?: string[];
}

export const VendorPicker = ({
  handleChange,
  defaultValue,
  value,
  placeholder,
  controlStyle,
  except,
}: IVendorPickerProps) => {
  const { data, loading } = useQuery(GET_VENDORS);

  const filtered = without([value], except ?? []);

  const availableVendors = data?.vendors ?? [];
  const selectedVendor =
    availableVendors.find((vendor) => vendor.id === (value ?? defaultValue)) ??
    null;

  const options =
    availableVendors.filter((vendor) => !filtered?.includes(vendor.id)) ?? [];

  return (
    <Box
      style={{
        width: "100%",
        marginTop: "20px",
        marginBottom: "20px",
        ...controlStyle,
      }}
    >
      <Autocomplete
        fullWidth
        // @ts-ignore
        value={selectedVendor}
        options={options}
        disableClearable
        loading={loading}
        getOptionLabel={(option) => option?.name ?? ""}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        onChange={(_, newValue) => {
          handleChange(newValue?.id ?? "", newValue ?? null);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Vendor"
            placeholder={placeholder ?? "Select a Vendor"}
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    </Box>
  );
};
